import { render, staticRenderFns } from "./orderTypeList.vue?vue&type=template&id=29169183&scoped=true"
import script from "./orderTypeList.vue?vue&type=script&lang=js"
export * from "./orderTypeList.vue?vue&type=script&lang=js"
import style0 from "./orderTypeList.vue?vue&type=style&index=0&id=29169183&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29169183",
  null
  
)

export default component.exports